import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { DiscoveryRow as DiscoveryRowType } from '../../data/discoveryRowsData';
import { BookCatalogEntry } from '../../data/booksData';
import UnifiedBookCard from '../Books/UnifiedBookCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { Carousel } from '../shared/Carousel';
interface DiscoveryRowProps {
  row: DiscoveryRowType;
  books: BookCatalogEntry[];
}
const DiscoveryRow: React.FC<DiscoveryRowProps> = ({
  row,
  books
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  if (!books || books.length === 0) return null;
  return <section className={`py-8 ${dk.page}`} data-id="element-1755" data-mp="v7kp9iwe90jg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1756" data-mp="vaqcstpdjud2">
        <div className="flex items-end justify-between mb-6" data-id="element-1757" data-mp="2blkmun7roe3j">
          <div data-id="element-1758" data-mp="26o17fjzc1va0">
            <h2 className={`text-2xl font-bold flex items-center ${dk.textHeading}`} data-id="element-1759" data-mp="26okeu6rcx19s">
              {row.emoji && <span className="mr-3 text-2xl" data-id="element-1760" data-mp="30z7qkrd76gme">{row.emoji}</span>}
              <span className={row.accentColor} data-id="element-1761" data-mp="350kz597ocxx0">{row.title}</span>
            </h2>
            {row.description && <p className={`mt-1 text-sm ${dk.textSecondary}`} data-id="element-1762" data-mp="3a1gz5bownzx5">
                {row.description}
              </p>}
          </div>
          {row.linkTo && <Link to={row.linkTo} className={`font-medium flex items-center text-sm sm:text-base ${rt.accentLink}`} data-id="element-1763" data-mp="2hca2yjcxbmf2">
              View all
              <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-1764" data-mp="2r9y17j9qnc1z" />
            </Link>}
        </div>

        <Carousel label={row.title} data-id="element-1765" data-mp="2w0o7qztwhky9">
          {books.map(book => <div key={book.id} className="flex-shrink-0 w-[160px] sm:w-[200px] snap-start" data-id="element-1766" data-mp="2w2r401lncabf">
              <UnifiedBookCard book={book} data-id="element-1767" data-mp="23k3pj515ntjb" />
            </div>)}
        </Carousel>
      </div>
    </section>;
};
export default DiscoveryRow;